<template>
  <div class="container sub-page">
    <div class="edit-company">
      <p style="text-align: left;font-size: 0.8rem;margin-bottom: 10px">企业名称:</p>
      <cube-input style="width: 100%" placeholder="企业名称" v-model="changeData.orgName"></cube-input>
      <p style="text-align: left;font-size: 0.8rem;margin-bottom: 10px;margin-top: 10px">企业简介:</p>
      <cube-textarea
        v-model="changeData.corpEName"
        placeholder="企业简介"
        :row="5"
        style="width: 100%;margin: 10px 0;height:160px"
      ></cube-textarea>
      <p style="text-align: left;font-size: 0.8rem;margin-bottom: 10px">联系方式:</p>
      <cube-input style="width: 100%" placeholder="联系方式" v-model="changeData.managerPhone"></cube-input>
    </div>
    <div class="group-row" style="margin-top: 30px;">
      <button class="my-btn" @click="change()">提交</button>
    </div>
    <div class="tab">
      <cube-tab-bar class="bl" v-model="selectedLabelDefault" :data="tabs" @change="changeHandler"></cube-tab-bar>
    </div>
  </div>
</template>

<script>
import axios from "axios"; // 引入axios
import { getCitys } from "@/api/bapi";
import { addUser2 } from "@/api/bapi";
import { getOrgDetail } from "@/api/bapi";
export default {
  name: "Company",
  data() {
    return {
      selectedLabelDefault: "我的",
      tabs: [
        {
          label: "首页",
          icon: "cubeic-home"
        },
        {
          label: "我的",
          icon: "cubeic-person"
        }
      ],
      changeData: {},
      userInfo:{},
    };
  },
  watch: {
    $route(to, from) {
      if (/\/Company/gi.test(to.path)) {
        this.getInfo();
      }
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      let userInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
      this.getChangeData(userInfo.sysUser.orgId);
    },
    getChangeData(id) {
      getOrgDetail(id)
        .then(res => {
          this.changeData = res.data.data;
        })
        .catch(function(reason) {
          this.$Message.error("您暂无权限");
        });
    },
    changeHandler(label) {
      if (label == "我的") {
        this.$router.push({ path: "Center" });
      } else {
        this.$router.push({ path: "Index" });
      }
    },
    erroruShow(msg) {
      this.$Message.error(msg);
      setTimeout(() => {
        this.changeMd = false;
        this.$nextTick(() => {
          this.changeMd = true;
        });
      }, 100);
    },
    //修改信息
    change() {
      let uer = JSON.stringify(this.changeData);
      if (!this.changeData.orgName || this.changeData.orgName == "") {
        this.erroruShow("请输入机构名称");
      } else if (
        !this.changeData.corpEName ||
        this.changeData.corpEName == ""
      ) {
        this.erroruShow("请输入简介");
      } else if (
        !this.changeData.managerPhone ||
        this.changeData.managerPhone == ""
      ) {
        this.erroruShow("请输入联系方式");
      } else {
        addUser2(uer)
          .then(res => {
            if (res.status == 200) {
              if (res.data.code == 0) {
                this.$Message.success("修改成功！");
              } else {
                this.erroruShow(res.data.msg);
              }
            }
          })
          .catch(function(reason) {});
      }
    }
  }
};
</script>

<style scoped>
.list {
  width: 100%;
  margin: 20px auto 0;
  text-align: left;
}
.list li {
  padding: 20px;
  background-color: white;
  border-bottom: 1px solid rgb(222, 221, 221);
}
</style>
<style lang="scss" scoped>
@import "../assets/css/rem.scss";
.edit-company {
  padding-top: rem(30);
}
</style>


// WEBPACK FOOTER //
// src/components/Company.vue